import {PASSWORD_STRENGTH_CONDITIONS} from "./constants/PasswordStrengthConditions";
import {PASSWORD_REQUIREMENTS} from "./constants/PasswordRequirements";
import {PASSWORD_STRENGTHS} from "./constants/PasswordStrengths";
import _forEach from "lodash/forEach"

class PasswordStrengthService {

  static getStrengthRating = (strength) => {
    let strengthRating = PASSWORD_STRENGTHS.NONE;

    _forEach(PASSWORD_STRENGTH_CONDITIONS, (category) => {
      if (category.strengthEvaluation(strength)) {
        strengthRating = category.strength;
        return false;
      }
    });

    return strengthRating;
  };

  static processPasswordRequirements = (password) =>  {
    let requirementsMet = [];

    _forEach(PASSWORD_REQUIREMENTS, (category) => {
      if (category.evaluate(password)) {
        requirementsMet.push(category.requirement);
      }
    });

    return requirementsMet;
  };

}

export default PasswordStrengthService;